import apiClient from "QueryClient/axiosClient";
import { AUTH_POLICY_EXPLICIT } from "QueryClient/authInterceptors";

export const findCollegesApi = ({
  accessToken,
  idempotencyKey,
  correlationId,
} = {}) => {
  const headers = {};
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
  if (idempotencyKey) headers["Idempotency-Key"] = idempotencyKey;
  if (correlationId) headers["X-Request-ID"] = correlationId;

  const config = Object.keys(headers).length
    ? {
        headers,
        onegradAuthPolicy: AUTH_POLICY_EXPLICIT,
      }
    : undefined;

  return apiClient.post(
    "/collegeFinder/generateRecommendations",
    undefined,
    config
  );
};

export const updateCollegeFinderDetails = (data) => {
  return apiClient.put("/users/updateCollegeFinderDetails", data);
};
